import { render } from "./ToolBarVistaCentros.vue?vue&type=template&id=30d68a17"
import script from "./ToolBarVistaCentros.vue?vue&type=script&lang=js"
export * from "./ToolBarVistaCentros.vue?vue&type=script&lang=js"

import exportComponent from "/home/nodejs/front/oxyplus-acuicultura-monitorweb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__